import { approverRequestsListsData } from '../../components/common/config/tabsConfig'
import Tabs from '../../components/common/Tabs'
import React from 'react'

const STORAGE_KEY_TAB = 'approverActiveTab'

/**
 * Renders the approver tab shell containing the Incoming Requests and History tabs.
 *
 * Active tab selection is persisted to sessionStorage so a page refresh returns
 * the user to the same tab they were on.  Badge counts are maintained via
 * `updateDataCount` which each child component can call to reflect live data.
 */
const ApproverTabs = () => {
const [dataLength, setDataLength] = React.useState<Record<number, number>>({})
  // Restore the last active tab from sessionStorage (default: tab 1)
  const [activeTab, setActiveTab] = React.useState<number>(() => {
    const saved = sessionStorage.getItem(STORAGE_KEY_TAB)
    return saved ? Number(saved) : 1
  })

  /**
   * Updates the active tab and persists the choice to sessionStorage so the
   * selection survives a page refresh.
   *
   * @param id - The numeric ID of the tab to activate.
   */
  const handleTabChange = React.useCallback((id: number) => {
    setActiveTab(id)
    sessionStorage.setItem(STORAGE_KEY_TAB, String(id))
  }, [])

  /**
   * Generic updater passed to each tab via `extraProps.updateDataCount`.
   * Allows child tab components to reflect the live record count on the tab label.
   *
   * @param tabId  - The numeric ID of the tab to update (1 = Incoming, 2 = History).
   * @param count  - The new record count to display on the tab badge.
   */
  const updateDataCount = React.useCallback((tabId: number, count: number) => {
    setDataLength(prev => ({ ...prev, [tabId]: count }))
  }, [])

  return (
    <div className='mt-8 tablet:mt-20 !mb-6'>
      <Tabs
        tabs={approverRequestsListsData}
        dataLength={dataLength}
        activeTab={activeTab}
        setActiveTab={handleTabChange}
        extraProps={{
          updateDataCount,
        }}
      />
    </div>
  )
}

export default ApproverTabs
